export const ENGLISH = 1;
type English = 1;
export const SPANISH = 2;
type Spanish = 2;
export type UrlLanguageId = English | Spanish;